(function () {
  function slugify(value, fallback) {
    var base = (value || fallback || 'section')
      .toString()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    return base || fallback || 'section';
  }

  function setButtonLabel(button, label) {
    var labelNode = button.querySelector('span:last-child');
    if (labelNode) {
      labelNode.textContent = label;
    } else {
      button.textContent = label;
    }
  }

  function flashButtonState(button) {
    var defaultLabel = button.getAttribute('data-default-label') || button.textContent.trim();
    var successLabel = button.getAttribute('data-success-label') || defaultLabel;
    setButtonLabel(button, successLabel);
    window.setTimeout(function () {
      setButtonLabel(button, defaultLabel);
    }, 1800);
  }

  var linkRewrites = {
    '/collections/coffee-beans': '/collections/cafe-en-grain',
    '/collections/single-origin-coffee': '/collections/pure-origine',
    '/collections/accessories': '/collections/accessoires',
    '/collections/ground-coffee-and-capsules': '/collections/cafe-moulu'
  };

  function normalizeArticleLinks(root) {
    Array.prototype.slice.call(root.querySelectorAll('a[href]')).forEach(function (link) {
      var rawHref = link.getAttribute('href');
      if (!rawHref) return;

      try {
        var url = new URL(rawHref, window.location.origin);
        var nextPath = linkRewrites[url.pathname];
        if (!nextPath) return;

        url.pathname = nextPath;
        if (rawHref.charAt(0) === '/') {
          link.setAttribute('href', url.pathname + url.search + url.hash);
        } else {
          link.setAttribute('href', url.href);
        }
      } catch (error) {
        Object.keys(linkRewrites).some(function (oldPath) {
          if (rawHref.indexOf(oldPath) !== 0) return false;
          link.setAttribute('href', rawHref.replace(oldPath, linkRewrites[oldPath]));
          return true;
        });
      }
    });
  }

  async function copyCurrentUrl(button) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(window.location.href);
      } else {
        var field = document.createElement('input');
        field.value = window.location.href;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }

      flashButtonState(button);
    } catch (error) {
      console.warn('Unable to copy article URL.', error);
    }
  }

  function buildArticle(root) {
    normalizeArticleLinks(root);

    var content = root.querySelector('[data-kl-article-content]');
    if (!content) return;

    var toc = root.querySelector('[data-kl-toc]');
    var tocNav = root.querySelector('[data-kl-toc-nav]');
    var progressBar = root.querySelector('[data-kl-reading-progress]');
    var headings = Array.prototype.slice.call(content.querySelectorAll('h2, h3')).filter(function (heading) {
      return heading.textContent && heading.textContent.trim().length > 0;
    });

    if (toc && tocNav) {
      if (headings.length > 1) {
        var seenIds = {};
        headings.forEach(function (heading, index) {
          var id = heading.id || slugify(heading.textContent, 'section-' + (index + 1));
          var uniqueId = id;
          var duplicate = 2;

          while (seenIds[uniqueId] || (document.getElementById(uniqueId) && document.getElementById(uniqueId) !== heading)) {
            uniqueId = id + '-' + duplicate;
            duplicate += 1;
          }

          seenIds[uniqueId] = true;
          heading.id = uniqueId;

          var link = document.createElement('a');
          link.className = 'kl-article-template__toc-link';
          if (heading.tagName === 'H3') {
            link.className += ' kl-article-template__toc-link--h3';
          }
          link.href = '#' + uniqueId;
          link.textContent = heading.textContent.trim();
          link.setAttribute('data-target-id', uniqueId);
          tocNav.appendChild(link);
        });

        toc.hidden = false;
      } else {
        toc.hidden = true;
      }
    }

    var tocLinks = Array.prototype.slice.call(root.querySelectorAll('[data-target-id]'));

    function syncProgress() {
      if (!progressBar) return;

      var top = content.getBoundingClientRect().top + window.scrollY;
      var start = top - 160;
      var end = top + content.offsetHeight - window.innerHeight * 0.45;
      var distance = end - start;
      var ratio = distance > 0 ? (window.scrollY - start) / distance : 0;
      var progress = Math.max(0, Math.min(1, ratio));

      progressBar.style.width = progress * 100 + '%';
    }

    function syncActiveHeading() {
      if (!tocLinks.length || !headings.length) return;

      var activeId = headings[0].id;
      headings.forEach(function (heading) {
        if (heading.getBoundingClientRect().top <= 180) {
          activeId = heading.id;
        }
      });

      tocLinks.forEach(function (link) {
        link.classList.toggle('is-active', link.getAttribute('data-target-id') === activeId);
      });
    }

    syncProgress();
    syncActiveHeading();

    window.addEventListener(
      'scroll',
      function () {
        syncProgress();
        syncActiveHeading();
      },
      { passive: true }
    );

    window.addEventListener('resize', syncProgress);

    Array.prototype.slice.call(root.querySelectorAll('[data-kl-copy-link]')).forEach(function (button) {
      button.addEventListener('click', function () {
        copyCurrentUrl(button);
      });
    });

    Array.prototype.slice.call(root.querySelectorAll('[data-kl-share-link]')).forEach(function (button) {
      button.addEventListener('click', async function () {
        try {
          if (navigator.share) {
            await navigator.share({
              title: root.getAttribute('data-article-title') || document.title,
              text: root.getAttribute('data-article-title') || document.title,
              url: window.location.href
            });
          } else {
            await copyCurrentUrl(button);
          }
        } catch (error) {
          if (error && error.name !== 'AbortError') {
            console.warn('Unable to share article.', error);
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    Array.prototype.slice.call(document.querySelectorAll('[data-kl-article-root]')).forEach(buildArticle);
  });
})();
